// extracted by mini-css-extract-plugin
export default {"choice_container":"ChoiceContainer_choice_container__WoVP2","group_wrapper":"ChoiceContainer_group_wrapper__qQUfb","groupWrapper":"ChoiceContainer_groupWrapper__CqL2T"};